import "../css/app.scss";
import 'bootstrap';

/** Global Components */


$(() => {

	// Enable scrollspy
	$('body').scrollspy({ target: '#scrollspy' });

	// Smooth scroll for navigation links
	$('.navigation__link').on('click', function (e) {
  e.preventDefault();

  document.querySelector(this.hash).scrollIntoView({
    behavior: 'smooth'
  });
});


	/*-------------------------------------------
	  Slider with alt text display
	-------------------------------------------*/

	$('.image-slider').each(function () {
		var slider = $(this);
		var slides = slider.find('.image-slider__slide');
		var sliderCurrentIndex = $(this)
			.siblings('.image-slider__navigation')
			.find('.image-slider__current-slide-index');

		var currentIndex = 0;
		var sliding = false;

		// Function to show the correct alt text
		function showAltText(index) {
			// Hide all alt texts
			$('.image-alt').hide();

			// Show the one that matches current image index (loop.index is 1-based)
			var altToShow = $('.image-alt[data-indexText="' + (index + 1) + '"]');
			if (altToShow.length) {
				altToShow.show();
			}
		}

		// Show initial alt text
		showAltText(currentIndex);

		// On click, go to next slide
		slider.click(function () {
			if (!sliding) {
				sliding = true;
				var nextSlideIndex =
					currentIndex === slides.length - 1 ? 0 : currentIndex + 1;

				var currentSlide = $(slides[currentIndex]);
				var nextSlide = $(slides[nextSlideIndex]);

				// Update slide indicator
				sliderCurrentIndex.text(nextSlideIndex + 1);

				// Animate slides
				currentSlide.addClass('image-slider__slide--animate');
				nextSlide.addClass('image-slider__slide--current');

				// Show the corresponding alt text
				showAltText(nextSlideIndex);

				// Reset state after animation
				setTimeout(function () {
					currentIndex = nextSlideIndex;
					$('.image-slider__slide--animate').removeClass(
						'image-slider__slide--animate image-slider__slide--current'
					);
					sliding = false;
				}, 750);
			}
		});
	});

});
